import { apiRequest } from "@/api/ApiRequest";
import type { FileInfoTypes } from "@/types/FileTypes";
import { ApiMethod } from "@/types/Enums";

/**
 * Base API path
 * Format: /api/(admin/corp/person)/~
 * Used to organize routes by user role
 */
const _url = "/api/cmmn/file";

/** 파일 목록 조회 */
export const getFileList = async (params: Record<string, unknown>): Promise<FileInfoTypes[]> => {
  return await apiRequest<FileInfoTypes[]>({
    url: _url,
    params: params,
    useLoading: true,
  });
};
/** 파일 정보 조회 */
export const getFileInfo = async (url: string): Promise<Blob> => {
  const res = await apiRequest<Record<string, unknown>>({
    url: url,
    useLoading: true,
    responseType: "blob",
  });
  return res.data as Blob;
};
/** base64 이미지 파일 변환 */
export const getBase64ToFile = async (base64: string, tableName: string): Promise<string> => {
  return await apiRequest<string>({
    method: ApiMethod.POST,
    url: "/api/auth/base64ToImageFile",
    data: {
      base64Img: base64,
      tableName: tableName,
    },
  });
};
/** base64 이미지 추출 */
const extractBase64Images = (html: string): { base64: string; tag: string }[] => {
  const imgTags = html.match(/<img[^>]+src="(data:image\/[^;]+;base64,[^"]+)"/g) || [];
  return imgTags.map((tag) => {
    const src = tag.match(/src="(data:image\/[^;]+;base64,[^"]+)"/)![1];
    return { base64: src, tag };
  });
};
/** base64 이미지 대체 */
export const replaceBase64Images = async (html: string, tableName: string): Promise<string> => {
  const images = extractBase64Images(html);
  let newHtml = html;
  for (const { base64, tag } of images) {
    const filePath = await getBase64ToFile(base64, tableName);
    if (!filePath) return "";
    newHtml = newHtml.replace(tag, tag.replace(base64, filePath));
  }
  return newHtml;
};
/** 파일 다운로드 1개 */
export const downloadFile = async (url: string): Promise<void> => {
  return await apiRequest<void>({
    url: url,
    useLoading: true,
    responseType: "blob",
  });
};
/** 파일 다운로드 zip */
export const downloadFileZip = async (
  fileGroupId: string | string[]
): Promise<Record<string, unknown>> => {
  const groupIds = typeof fileGroupId === "string" ? [fileGroupId] : fileGroupId;
  return await apiRequest<Record<string, unknown>>({
    url: "/api/auth/files/zip",
    method: ApiMethod.POST,
    data: { groupIds },
    useLoading: true,
    responseType: "blob",
  });
};
